import React from 'react'
/*import "./css/grid.min-1.css";
import "./css/main.min-1.css";
import "./css/shiftup-core.min-1.css";
import "./css/frontend-lite.min-1.css";
import "./css/post-7267.css";*/

const createMarkup = () => {
  return { __html: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d416.8864952727322!2d-75.5877853706511!3d6.24856190765769!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e4429a78eb08e19%3A0x8e1edb180006411e!2sCra.%2069%20%2343-37%2C%20Laureles%20-%20Estadio%2C%20Medell%C3%ADn%2C%20Laureles%2C%20Medell%C3%ADn%2C%20Antioquia!5e0!3m2!1ses!2sco!4v1732855426992!5m2!1ses!2sco" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>' };
}

export const Maps = () => {
  return (
    <div >
    <div dangerouslySetInnerHTML={createMarkup()}></div>

    </div>
  )
}